const bootstrap = import("./bootstrap");
// This is a solution for this known issue from webpack federated modules shared dependencies.
// https://stackoverflow.com/questions/66123283/webpack-module-federation-is-not-working-with-eager-shared-libs
// eslint-disable-next-line import/no-unused-modules
export default bootstrap;
